<template>
  <v-form autocomplete="off">
    <v-divider
      class="mt-3"
      style="border-color: grey;"
    />
    <v-row>
      <!-- Ativar serviço -->
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-switch
          :input-value="value.enabled === '1'"
          class="font-weight-bold"
          :label="`${value.customName || name}: ${value.enabled === '1' ? 'Habilitado' : 'Desabilitado'}`"
          color="success"
          @change="val => { value.enabled = val ? '1' : '0'; updateValue() }"
        />
      </v-col>

      <!-- Data de criação -->
      <v-col
        v-if="value.enabled === '1'"
        cols="12"
        sm="6"
        md="4"
      >
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          readonly
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{}">
            <v-text-field
              v-mask="'####-##-##'"
              :value="value.createdAt"
              placeholder="AAAA-MM-DD"
              label="Data de criação"
              outlined
              dense
              prepend-icon="mdi-calendar"
              readonly
              @input="val => { value.createdAt = val; updateValue() }"
            />
          </template>
          <v-date-picker
            v-model="value.createdAt"
            class="pb-0 mb-0 mt-0 pt-5"
            no-title
            scrollable
            @input="dateMenu = false"
          />
        </v-menu>
      </v-col>
    </v-row>

    <!-- Limite de usuários -->
    <v-row
      align="center"
      justify="start"
    >
      <v-col
        v-if="value.limitUser !== undefined"
        cols="4"
      >
        <v-text-field
          :value="value.limitUser"
          type="number"
          label="Limite de Usuários:"
          @input="val => { value.limitUser = val; updateValue() }"
        />
      </v-col>

      <!-- Tema -->
      <v-col
        v-if="value.theme !== undefined"
        cols="4"
      >
        <v-select
          :value="value.theme"
          :items="['blueGreen', 'lighterWhite', 'darker', 'orange', 'red']"
          label="Temas:"
          outlined
          dense
          @input="val => { value.theme = val; updateValue() }"
        />
      </v-col>

      <!-- Logo -->
      <v-col
        v-if="value.logo !== undefined"
        cols="4"
      >
        <v-text-field
          :value="value.logo"
          label="Logo:"
          outlined
          dense
          @input="val => { value.logo = val; updateValue() }"
        />
      </v-col>

      <!-- Cor HTML -->
      <v-col
        v-if="value.colorHTML !== undefined"
        cols="4"
      >
        <v-text-field
          :value="value.colorHTML"
          label="Cor HTML"
          hide-details
          class="ma-0 pa-0"
          outlined
          dense
          solo
          @click="colorpickerMenu = true"
        >
          <template v-slot:append>
            <v-menu
              v-model="colorpickerMenu"
              top
              nudge-bottom="105"
              nudge-left="16"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <div
                  :style="swatchStyle"
                  v-on="on"
                />
              </template>
              <v-card>
                <v-card-text class="pa-0">
                  <v-color-picker
                    :value="value.colorHTML"
                    flat
                    @input="val => { value.colorHTML = val; updateValue() }"
                  />
                </v-card-text>
              </v-card>
            </v-menu>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <!-- Switches adicionais -->
    <v-row class="ps-3">
      <v-col
        v-for="(label, key) in switchFields"
        :key="key"
        cols="6"
      >
        <v-switch
          v-if="key in value.settings"
          :input-value="value.settings[key] === '1'"
          :label="label"
          @change="val => { value.settings[key] = val ? '1' : '0'; updateValue() }"
        />
      </v-col>
    </v-row>

    <v-row class="ps-3">
      <v-col
        v-for="(options, key) in selectFields"
        :key="key"
        cols="12"
        md="3"
        sm="6"
      >
        <v-select
          v-if="key in value.settings"
          :value="value.settings[key]"
          :items="options.items"
          :label="options.label"
          outlined
          dense
          @input="val => { value.settings[key] = val; updateValue() }"
        />
      </v-col>
    </v-row>

    <!-- TextFields -->
    <v-row class="ps-3">
      <v-col
        v-for="(label, key) in textFields"
        :key="key"
        class="px-3"
        cols="6"
      >
        <v-text-field
          v-if="key in value.settings"
          :value="value.settings[key]"
          :label="label"
          outlined
          dense
          @input="val => { value.settings[key] = val; updateValue() }"
        />
      </v-col>
    </v-row>

    <!-- Margens -->
    <v-row class="ps-3">
      <v-row class="ps-3 pb-0">
        <strong>Margens</strong>
      </v-row>

      <v-row>
        <v-col
          v-for="(label, key) in marginFields"
          :key="key"
          class="ps-6 pt-1"
          cols="6"
        >
          <v-row class="my-1">
            <v-col cols="3">
              <v-text-field
                v-if="key in value.settings"
                :value="value.settings[key][0]"
                label="Superior"
                outlined
                dense
                @input="val => { value.settings[key][0] = val; updateValue() }"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-if="key in value.settings"
                :value="value.settings[key][1]"
                label="Direita"
                outlined
                dense
                @input="val => { value.settings[key][1] = val; updateValue() }"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-if="key in value.settings"
                :value="value.settings[key][2]"
                label="Inferior"
                outlined
                dense
                @input="val => { value.settings[key][2] = val; updateValue() }"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-if="key in value.settings"
                :value="value.settings[key][3]"
                label="Esquerda"
                outlined
                dense
                @input="val => { value.settings[key][3] = val; updateValue() }"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>

    <div class="py-3" />
    <v-divider
      class="pt-3 pb-3"
      style="border-color: grey;"
    />
  </v-form>
</template>

<script>
  import { mask } from 'vue-the-mask'
  import moment from 'moment'

  export default {
    name: 'ServiceBox',
    directives: { mask },
    model: { prop: 'value', event: 'input' },
    props: {
      name: { type: String, required: true },
      value: {
        type: Object,
        required: false,
        default: () => ({ enabled: '0', createdAt: null }),
      },
    },
    data: () => ({
      dateMenu: false,
      colorpickerMenu: false,
      switchFields: {
        clinicWeb_medicalRecord_preset: 'Predefinição de prontuário',
        clinicWeb_medicalRecord_showDuration: 'Mostrar duração de prontuário',
        clinicWeb_medicalRecord_useMemed: 'Usar Memed no prontuário',
        clinicWeb_medicalRecord_selfEvolutionOnly: 'Mostrar apenas evoluções do profissional',
        clinicWeb_printables_headerShowName: 'Exibir nome no cabeçalho',
        clinicWeb_printables_headerShowLogo: 'Exibir logo no cabeçalho',
        clinicWeb_printables_showBoardLabel: 'Exibir nome do conselho',
        clinicWeb_printables_showBoard: 'Exibir número do conselho',
        clinicWeb_schedule_showPatientArrival: 'Exibir tempo de chegada do paciente',
        clinicWeb_schedule_showPatientWaiting: 'Exibir tempo de espera do paciente',
      },
      selectFields: {
        clinicWeb_printables_logoPosition: {
          label: 'Posição do Logo',
          items: ['footer-start', 'footer-center', 'footer-end'],
        },
        clinicWeb_printables_footerPosition: {
          label: 'Posição do Rodapé',
          items: ['footer-start', 'footer-center', 'footer-end'],
        },
        clinicWeb_printables_pageSize: {
          label: 'Tamanho da Página',
          items: ['A4', 'A5'],
        },
      },
      textFields: {
        clinicWeb_printables_fontSize: 'Tamanho da Fonte',
        clinicWeb_printables_footerText: 'Texto do Rodapé',
      },
      marginFields: {
        clinicWeb_printables_margins: 'Margens',
      },
    }),
    computed: {
      swatchStyle () {
        return {
          backgroundColor: this.value.colorHTML,
          cursor: 'pointer',
          height: '30px',
          width: '30px',
          borderRadius: this.colorpickerMenu ? '50%' : '4px',
          transition: 'border-radius 200ms ease-in-out',
        }
      },
    },
    watch: {
      'value.enabled': {
        immediate: true,
        handler (val) {
          if (val === '1' && !this.value.createdAt) {
            this.value.createdAt = moment().toISOString()
            this.updateValue()
          }
        },
      },
      value: {
        deep: true,
        immediate: true,
        handler (val) {
          if (typeof val.enabled === 'boolean') {
            val.enabled = val.enabled ? '1' : '0'
          }

          if (val.settings) {
            for (const key in this.switchFields) {
              if (val.settings[key] !== undefined && typeof val.settings[key] === 'boolean') {
                val.settings[key] = val.settings[key] ? '1' : '0'
              }
            }
          }
        },
      },
    },
    methods: {
      updateValue () {
        this.$emit('input', this.value)
      },
      formatDataForServer () {
        const formatted = JSON.parse(JSON.stringify(this.value))
        formatted.settings = formatted.settings || {}

        for (const key in formatted.settings) {
          if (typeof formatted.settings[key] === 'boolean') {
            formatted.settings[key] = formatted.settings[key] ? '1' : '0'
          }
        }

        // converte margens
        if (Array.isArray(formatted.settings.clinicWeb_printables_margins)) {
          formatted.settings.clinicWeb_printables_margins =
            formatted.settings.clinicWeb_printables_margins.map(m => `${m}cm`).join(' ')
        }

        return formatted
      },
    },
  }
</script>
